import {RouterModule, Routes} from '@angular/router';
import {AppComponent} from './app.component';

import {AuthGuard} from './core/guards/autenticacao.guard';
import {AdminGuard} from './core/guards/admin.guard';

const appRoutes: Routes = [
  {path: 'login', loadChildren: './login/login.module#LoginModule'},
  {
    path: '', canActivate: [AuthGuard], children: [
    {
      path: 'admin', canActivate: [AdminGuard],
      children: [
        {path: 'teste', loadChildren: './teste/teste.module#TesteModule'},
        {path: '', loadChildren: './config/config.module#ConfigModule'}
      ]
    },
    {path: 'mobile', loadChildren: './mobile/mobile.module#MobileModule'},
    {
      path: 'gestao',
      children: [
        {path: '', loadChildren: './gestao/gestao.module#GestaoModule'}
      ]
    }
  ]
  },
  {path: 'login', loadChildren: './login/login.module#LoginModule'},
  {path: '**', redirectTo: '/login', pathMatch: 'full'}
];

export const appRouting = {
  routes: RouterModule.forRoot(appRoutes),
  components: [AppComponent]
};
